import PropTypes from 'prop-types';
// @mui
import { Box, Stack, Typography, IconButton } from '@mui/material';
import Iconify from 'src/components/iconify';

export default function JobCandidateFilterResult({
  filteredCandidateList,
  setFilteredCandidateList,
  filterResultsCount,
  setShowFilterResults,
  setShowNavbar,
}) {
  return (
    <Box
      sx={{
        bgcolor: theme => theme.palette.background.primaryAccent2,
        color: theme => theme.palette.content.accent1,
        px: '16px',
        py: '7.5px',
        borderRadius: '6px',
        width: 'fit-content',
      }}
    >
      <Stack direction="row" alignItems="center" spacing="8px">
        <Typography variant="h4">
          Filter results {`${filterResultsCount}`}
        </Typography>
        <IconButton
          onClick={() => {
            setShowFilterResults(false);
            setFilteredCandidateList([]);
            setShowNavbar(true);
          }}
        >
          <Iconify
            sx={{
              color: theme => theme.palette.content.accent1,
            }}
            icon="tabler:x"
          />
        </IconButton>
      </Stack>
    </Box>
  );
}

JobCandidateFilterResult.propTypes = {
  filteredCandidateList: PropTypes.array.isRequired,
  setFilteredCandidateList: PropTypes.func.isRequired,
  filterResultsCount: PropTypes.number.isRequired,
  setShowFilterResults: PropTypes.func.isRequired,
  setShowNavbar: PropTypes.func.isRequired,
};
